// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__3KnF_","bookingInfo":"BookingTimeInfo_bookingInfo__2HA36","dateSection":"BookingTimeInfo_dateSection__30nFM"};